import React from "react";
import style from "./TriStateAnswer.module.scss";

/**
 * The three-state prerequisite answer.
 *
 * Yes · No · N/A — and crucially there is no fourth state that ends the
 * workflow. V1 terminated on `consent → No`; here "No" opens a reason and the
 * record carries on. Nothing this component renders may disable anything else.
 *
 * Not a react-hook-form field: the answer is compound (value + reason) and
 * lives in the hook's state object, so it is a controlled component instead.
 */
export const TriStateAnswer = ({ name, value, onChange, disabled = false }) => {
  const options = [
    { key: "yes", label: "Yes" },
    { key: "no", label: "No" },
    { key: "na", label: "N/A" },
  ];

  return (
    <div className={style.tristate} role="group" aria-label={`${name} answer`}>
      {options.map((o) => (
        <button
          key={o.key}
          type="button"
          data-testid={`${name}-${o.key}`}
          data-answer={o.key}
          className={style.tristate_btn}
          aria-pressed={value === o.key}
          disabled={disabled}
          onClick={() => onChange(o.key)}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
};
